<template>
  <span v-if="canManage">
    <el-button size="small" @click="open">经营设置</el-button>
    <el-dialog title="企业经营设置" :visible.sync="visible" width="560px" append-to-body>
      <el-form label-width="140px" v-loading="loading">
        <el-form-item label="产品目录"><el-switch v-model="form.productsEnabled" /></el-form-item>
        <el-form-item label="销售订单"><el-switch v-model="form.ordersEnabled" /></el-form-item>
        <el-form-item label="销售发票"><el-switch v-model="form.invoicesEnabled" /></el-form-item>
        <p class="hint">关闭模块后隐藏本企业菜单并禁止写入。已有单据与报价明细仍可查看；重新开启即可继续使用。</p>
        <el-form-item label="每日经营摘要"><el-switch v-model="form.digestEnabled" /></el-form-item>
        <p class="hint">启用后每天北京时间9点，为启用的主管和管理员生成昨日新增线索、客户与当前逾期回款的站内待办。每人按自己的数据范围统计，仅本人可见。同一天不会重复生成，历史摘要保留。</p>
        <el-button size="small" :disabled="!savedDigestEnabled" :loading="sending" @click="send">补发今日摘要</el-button>
        <p class="hint">补发以已保存的设置为准，先保存再补发。</p>
      </el-form>
      <span slot="footer"><el-button @click="visible=false">关闭</el-button><el-button type="primary" :loading="saving" @click="save">保存设置</el-button></span>
    </el-dialog>
  </span>
</template>
<script>
import { crm } from '../api/crm'
export default {
  data:()=>({visible:false,loading:false,saving:false,sending:false,savedDigestEnabled:false,form:{}}),
  computed:{canManage(){const u=this.$store.state.user || {};return ['TENANT_ADMIN','PLATFORM_ADMIN'].some(r=>u.roleCode===r || (u.roleCodes || []).includes(r))}},
  methods:{
    async open(){this.visible=true;this.loading=true;try{const res=await crm.operatingSettings();this.form=res.data;this.savedDigestEnabled=!!res.data.digestEnabled}finally{this.loading=false}},
    async save(){this.saving=true;try{const res=await crm.saveOperatingSettings(this.form);this.form=res.data;this.savedDigestEnabled=!!res.data.digestEnabled;window.dispatchEvent(new Event('crm-settings-changed'));this.$message.success('设置已保存')}finally{this.saving=false}},
    async send(){this.sending=true;try{const res=await crm.sendDailyDigest();this.$message.success('已生成'+res.data.created+'条摘要；已生成的摘要不会重复发送')}finally{this.sending=false}}
  }
}
</script>
<style scoped>.hint{color:#64748b;font-size:13px;line-height:1.7;margin:0 0 20px}</style>
